export var ODEntityEditorContextActionType;
(function (ODEntityEditorContextActionType) {
    ODEntityEditorContextActionType["TYPE_SET_LOADING"] = "ODEntityEditorContext/TYPE_SET_LOADING";
    ODEntityEditorContextActionType["TYPE_VALUE_LOADED"] = "ODEntityEditorContext/TYPE_VALUE_LOADED";
    ODEntityEditorContextActionType["TYPE_INITIAL_VALUE_LOAD_FAILED"] = "ODEntityEditorContext/TYPE_INITIAL_VALUE_LOAD_FAILED";
    ODEntityEditorContextActionType["TYPE_SET_URL_TO_REDIRECT"] = "ODEntityEditorContext/TYPE_SET_URL_TO_REDIRECT";
    ODEntityEditorContextActionType["TYPE_SET_SAVING"] = "ODEntityEditorContext/TYPE_SET_SAVING";
    ODEntityEditorContextActionType["TYPE_SET_DELETING"] = "ODEntityEditorContext/TYPE_SET_DELETING";
    ODEntityEditorContextActionType["TYPE_MODIFY_CLIENT_VALUE"] = "ODEntityEditorContext/TYPE_MODIFY_CLIENT_VALUE";
})(ODEntityEditorContextActionType || (ODEntityEditorContextActionType = {}));
export var actionSetLoading = function (loading) { return ({
    type: ODEntityEditorContextActionType.TYPE_SET_LOADING,
    loading: loading,
}); };
export var LoadedValueType;
(function (LoadedValueType) {
    LoadedValueType[LoadedValueType["InitialCreating"] = 0] = "InitialCreating";
    LoadedValueType[LoadedValueType["InitialLoaded"] = 1] = "InitialLoaded";
    LoadedValueType[LoadedValueType["UpdateLoaded"] = 2] = "UpdateLoaded";
})(LoadedValueType || (LoadedValueType = {}));
export var actionValueLoaded = function (clientValue, loadedValueType) { return ({
    type: ODEntityEditorContextActionType.TYPE_VALUE_LOADED,
    clientValue: clientValue,
    loadedValueType: loadedValueType,
}); };
export var actionInitialValueLoadFailed = function (error) { return ({
    type: ODEntityEditorContextActionType.TYPE_INITIAL_VALUE_LOAD_FAILED,
    error: error,
}); };
export var actionSetUrlToRedirect = function (urlToRedirect) { return ({
    type: ODEntityEditorContextActionType.TYPE_SET_URL_TO_REDIRECT,
    urlToRedirect: urlToRedirect,
}); };
export var actionSetSaving = function (saving, isCreating) { return ({
    type: ODEntityEditorContextActionType.TYPE_SET_SAVING,
    saving: saving,
    isCreating: isCreating,
}); };
export var actionSetDeleting = function (deleting) { return ({
    type: ODEntityEditorContextActionType.TYPE_SET_DELETING,
    deleting: deleting,
}); };
export var actionModifyClientValue = function (modifyInPlace) { return ({
    type: ODEntityEditorContextActionType.TYPE_MODIFY_CLIENT_VALUE,
    modifyInPlace: modifyInPlace,
}); };
//# sourceMappingURL=action.js.map